import {Button, FloatingLabel, Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {CustomModal} from '../CustomModal'
import {useChatOrderModal} from './useChatOrderModal'

export const ChatOrderModal = () => {
  const {t} = useTranslation()
  const {openModal, notification, fullChat, setComment, getTime, handleCloseModal, handlePostChat} =
    useChatOrderModal()

  if (!notification) return null

  return (
    <CustomModal
      title={notification.title}
      show={openModal}
      size='lg'
      centered
      onHide={handleCloseModal}
    >
      <FloatingLabel controlId='floatingTextarea2' label={t('Chat')}>
        <Form.Control
          as='textarea'
          id='areachat'
          placeholder={t('Tinggal-pesan')}
          style={{height: '100px'}}
          onChange={(e: any) => setComment(e.target.value)}
        />
      </FloatingLabel>
      <div className='d-flex justify-content-end'>
        <Button variant='primary' className='mt-3 mb-3' onClick={() => handlePostChat()}>
          {t('Tambah')}
        </Button>
      </div>
      {fullChat?.length < 1 ? (
        ''
      ) : (
        <div className='table-responsive mt-10 bdr'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold w-100 align-items-center'>
                <th className='td-3 text-center px-0' style={{width: 70}}>
                  {t('no')}
                </th>
                <th className='td-3 text-center'>{t('order-tanggal')}</th>
                {/* <th className='td-3 text-center'>{t('User Code')}</th> */}
                <th className='td-3 text-center'>{t('order-user')}</th>
                <th className='td-3 text-center'>{t('Chat')}</th>
              </tr>
            </thead>
            {fullChat?.map((item: any, _index: number) => (
              <tbody key={item?.customer_code ?? _index}>
                <tr className='w-100 align-items-center'>
                  <td className='text-center' style={{width: 70}}>
                    {_index + 1}
                  </td>
                  <td className='td-150 text-center'>{getTime(item.created_at)}</td>
                  {/* <td className='td-150 text-center'>
                    {item.user?.customer_code || item.user?.nama_pengguna}
                  </td> */}
                  <td className='td-150 text-center'>{item.user?.name}</td>
                  <td className='td-60 text-center'>
                    <div style={{textAlign: 'justify', padding: '0 0.775rem'}}>{item.comment}</div>
                  </td>
                </tr>
              </tbody>
            ))}
          </table>
        </div>
      )}
    </CustomModal>
  )
}
